class CompositeDataSource {
    init(resourceConfiguration,dataResources){
        let {resourceComposer} = resourceConfiguration;
        let compositeData = resourceComposer(dataResources);
        return Promise.resolve({data:compositeData});
    }
}


export default CompositeDataSource;